module.exports = __webpack_public_path__ + "img/error-icon.2897a4c6.svg";